import React from "react";
import { withStyles } from "@material-ui/core";
import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import { useEffect, useMemo, useState } from "react";
import { withRouter } from "react-router-dom";
import MultiToggleButtons from "../../../../../../../../components/Button/MultiToggleButtons";
import Dialog from "../../../../../../../../components/Dialog/Dialog";
import CloseIcon from "../../../../../../../../components/Icon/Close";
import CopyIcon from "../../../../../../../../components/Icon/CopyIcon";
import PrintIcon from "../../../../../../../../components/Icon/Print";
import { checkUserRoles } from "../../../../../../../../components/RoleProtection";
import { Button } from "../../../../../../../../components/ui/Buttons";
import { findConfiguracaoUnidade } from "../../../../../../../../services/OdontogramaService";
import { copiarOrcamento, getStatusOrcamentoPadraoOdontologico } from "../../../../../../../../services/OrcamentoService";
import {
  defaultErrors,
  orcamentoDefault,
} from "../../../../../../../../stores/Orcamento.store";
import colors from "../../../../../../../../template/Colors";
import { tipoProfissionalSaude } from "../../../../../../../../utils/constants/tipoProfissionalSaude";
import TabObservacoes from "../../TabObservacoes";
import TabPagamento from "../../TabPagamento";
import HeaderOdontologico from "./HeaderOdontologico";
import TabHistorico from "./TabHistorico";
import Auditoria from "../../../../../../../../components/Auditoria/Auditoria";
import { findAllOrcamentoAuditByOrcamentoId } from "../../../../../../../../services/AuditoriaService";
import { justifyContent } from "styled-system";


const ModalOrcamento = observer(
  ({
    classes,
    open,
    title,
    orcamentoStore,
    children,
    handleSave,
    onClose,
    isLoadingSave,
    setIsLoadingSave,
    handlePrint,
    sujeitoAtencaoSelected,
    auditoriaStore,
    statusBack,
  }) => {
    const { orcamento, handleFieldModal } = orcamentoStore;
    const { statusOrcamentoOdontologico } = orcamento || {};

    const usuarioLogado = JSON.parse(localStorage[`_immortal|usuarioLogado`] || null);

    const canReadGerenciadorOrcamento = usuarioLogado.authorities.some(a =>
      a.authority === 'ROLE_GERENCIADOR_ORCAMENTO_READ');

    const tabs = useMemo(() => {
      if(!canReadGerenciadorOrcamento) {
        return {
          OBSERVACOES: 0,
          HISTORICO: 1,
          AUDITORIA: 2
        };
      }
      return {
        PAGAMENTO: 0,
        OBSERVACOES: 1,
        HISTORICO: 2,
        AUDITORIA: 3
      };
    }, [canReadGerenciadorOrcamento]);

    const [tabSelected, setTabSelected] = useState(canReadGerenciadorOrcamento ? tabs.PAGAMENTO : tabs.OBSERVACOES);
    const [configUnidade, setConfigUnidade] = useState(null);

    const profissionalSaudeLogado = JSON.parse(localStorage[`_immortal|profissional_saude_logado`] || null);

    const isAdministrador = tipoProfissionalSaude[profissionalSaudeLogado?.tipo] === "Administrador";
    const isStatusDisabled = statusBack?.tipo === "REPROVADO" || statusBack?.tipo === "APROVADO";

    useEffect(() => {
      getConfigUnidade();
      orcamentoStore.errors = defaultErrors;
      !orcamento?.id && getStatusPadraoOdontologico();
    }, []);

    const getStatusPadraoOdontologico = async () => {
      const statusPadraoOdontologico = await getStatusOrcamentoPadraoOdontologico();
      orcamentoStore.orcamento = {
        ...orcamento,
        statusOrcamentoOdontologico: statusPadraoOdontologico,
      };
    };

    const loadAudit = async () => {
      auditoriaStore.auditoriaProps = {
        ...auditoriaStore.auditoriaProps,
        auditoria: "o orçamento",
        auditoriaTela: "orcamentos",
        pageNumber: 0,
        lastPage: false,
        auditorias: [],
      };

      auditoriaStore.load = {
        query: findAllOrcamentoAuditByOrcamentoId,
        variableName: "orcamentoId",
        variableId: orcamento?.id,
      };

      await auditoriaStore.loadAuditItems()
    }

    const changeTabSelected = async (tabSelected) => {
      setTabSelected(tabSelected);
    };

    const getConfigUnidade = async () => {
      const configUnidade = await findConfiguracaoUnidade();

      setConfigUnidade(configUnidade);
    };

    const handleAction = async (action) => {
      try {
        setIsLoadingSave(true);
        await handleSave(action);
      } catch (e) {
        throw e;
      } finally {
        setIsLoadingSave(false);
      }
    };

    const renderTab = () => {
      const tabsOrcamento = {
        [tabs.PAGAMENTO]: (
          <TabPagamento
            configUnidade={configUnidade}
            orcamento={orcamento}
            handleFieldModal={handleFieldModal}
          />
        ),
        [tabs.OBSERVACOES]: (
          <TabObservacoes
            orcamento={orcamento}
            handleFieldModal={handleFieldModal}
          />
        ),
        [tabs.HISTORICO]: (
          <TabHistorico
            orcamento={orcamento}
            handleFieldModal={handleFieldModal}
          />
        ),
        [tabs.AUDITORIA]: <Auditoria />,
      };
    
      const tabsWithoutPagamento = {
        [tabs.OBSERVACOES]: (
          <TabObservacoes
            orcamento={orcamento}
            handleFieldModal={handleFieldModal}
          />
        ),
        [tabs.HISTORICO]: (
          <TabHistorico
            orcamento={orcamento}
            handleFieldModal={handleFieldModal}
          />
        ),
        [tabs.AUDITORIA]: <Auditoria />,
      };
    
      return canReadGerenciadorOrcamento 
        ? tabsOrcamento[tabSelected] 
        : tabsWithoutPagamento[tabSelected];
    };

    const permiteSalvar = async () => {
      const possuiPermissao = await checkUserRoles([
        "ROLE_ORCAMENTO_CREATE",
        "ROLE_ORCAMENTO_UPDATE",
      ]);

      const possuiTitulo = orcamento?.titulo?.id

      return possuiPermissao && !possuiTitulo;
    };

    const handleCopy = async () => {
      try {
        setIsLoadingSave(true);
        const response = await copiarOrcamento(orcamento.id);

        orcamentoStore.getDadosOrcamentoOdontologico(
          response.id,
          sujeitoAtencaoSelected?.id || orcamento?.sujeitoAtencao?.id,
          response || orcamentoDefault
        );
      } catch (e) {
        throw e;
      } finally {
        setIsLoadingSave(false);
      }
    };

    useEffect(() => {
      if(tabSelected === tabs.AUDITORIA) {
        loadAudit();
      }
    }, [tabSelected])

    return (
      <Dialog
        open={open}
        onClose={onClose}
        classes={{
          paper: classes.dialog,
        }}
      >
        <div className={classes.header}>
          {title}
          <div className={classes.buttonsHeader}>
            {orcamento?.id && configUnidade?.permiteDuplicidadeOrcamento && (
              <Button
                id="prt-mor-btn-cop"
                bgColor={"#FBBF6D"}
                onClick={handleCopy}
                disabled={isLoadingSave || !permiteSalvar()}
                shape="circle"
              >
                <CopyIcon />
              </Button>
            )}
            <Button
              id="prt-mor-btn-imp"
              className={classes.buttonImprimir}
              onClick={() => handlePrint()}
              disabled={isLoadingSave}
            >
              <PrintIcon />
            </Button>
            <Button id="prt-mor-btn-fch" bgColor="#FB7676" shape="circle" onClick={onClose}>
              <CloseIcon />
            </Button>
          </div>
        </div>
        <div className={classes.content}>
          <HeaderOdontologico
            sujeitoAtencao={sujeitoAtencaoSelected || orcamento?.sujeitoAtencao}
            orcamento={orcamento}
            handleFieldModal={handleFieldModal}
          />
          <MultiToggleButtons
            id="prt-mor-btn-tab"
            options={
              canReadGerenciadorOrcamento
              ? ["Pagamento", "Observações", "Histórico", "Auditoria"]
              : ["Observações", "Histórico", "Auditoria"]
            }
            tabSelected={tabSelected}
            changeTabSelected={changeTabSelected}
            disabled={!orcamento?.id}
            posicaoDesabilitada={[2]}
          />
          {renderTab()}
          {![tabs.HISTORICO, tabs.AUDITORIA].includes(tabSelected) && children}
        </div>
        <div className={classes.buttons}>
            <Button
              id="prt-mor-btn-slv"
              bgColor="#707C97"
              onClick={() => handleAction(statusOrcamentoOdontologico?.tipo)}
              width="205px"
              disabled={
                !permiteSalvar() || isLoadingSave || (!isAdministrador && isStatusDisabled) || tabSelected === tabs.HISTORICO
              }
              isLoading={isLoadingSave}
            >
              Salvar
            </Button>
        </div>
      </Dialog>
    );
  }
);

const styles = {
  dialog: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    padding: "16px 21px 21px 32px",
    width: "100%",
    maxWidth: "800px",
    height: "100%",
    maxHeight: "700px",
    overflow: "hidden",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "18px",
    fontWeight: "700",
    color: "#333333",
  },
  content: {
    height: "100%",
    maxHeight: "calc(100% - 113px)",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    padding:"5px",
    justifyContent:"space-between"
  },
  buttons: {
    display: "flex",
    justifyContent: "space-between",
  },
  contentField: {
    display: "flex",
    flexDirection: "column",
  },
  titleField: {
    color: "#868686",
  },
  buttonImprimir: {
    backgroundColor: colors.commons.secondary,
    width: "40px",
    height: "40px",
    color: "white",
    "&:hover": {
      background: colors.primary.dark,
    },
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0px !important",
  },
  buttonsHeader: {
    display: "flex",
    gap: "10px",
  },
};

const ModalOrcamentoWithStyles = withRouter(withStyles(styles)(ModalOrcamento));
export default inject(
  "odontogramaStore",
  "prontuarioStore",
  "orcamentoStore",
  "auditoriaStore"
)(ModalOrcamentoWithStyles);
